var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagMangoWithoutBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5452 3.1408C14.8922 3.00103 15.2466 2.88052 15.6068 2.77981C16.3355 2.63319 17.0921 2.72904 17.7617 3.05285C18.6404 3.45941 19.4391 4.02145 20.1194 4.71205C20.1667 4.75073 20.2057 4.79861 20.2341 4.85281C20.2624 4.90701 20.2796 4.96641 20.2845 5.02744C20.2894 5.08848 20.282 5.14987 20.2626 5.20794C20.2433 5.26601 20.2124 5.31956 20.1719 5.36535C19.3864 6.29313 18.377 7.00336 17.2401 7.42825C16.5614 7.66419 15.8229 7.66124 15.1461 7.41987C15.1206 7.41275 15.0947 7.40744 15.0685 7.40396C15.2354 7.72056 15.4198 8.01789 15.5692 8.3303C15.991 9.17594 16.1944 10.1144 16.1608 11.0595C16.1271 12.0045 15.8574 12.926 15.3764 13.7392C14.0374 16.2746 11.8932 18.2887 9.28399 19.4623C7.8426 20.1032 6.26609 20.3779 4.69379 20.2621C3.96353 20.2434 3.24226 20.0957 2.5631 19.8258C2.02334 19.6107 1.56695 19.2269 1.2615 18.7312C0.956063 18.2355 0.817813 17.6543 0.867228 17.0735C0.914467 16.2161 1.27592 15.4065 1.88208 14.8004C2.29202 14.3615 2.56124 13.8091 2.6549 13.2149C2.83768 12.266 2.98039 11.307 3.19738 10.3672C3.42092 9.33148 3.86476 8.3564 4.49855 7.50873C5.13234 6.66105 5.94112 5.96077 6.86954 5.4558C7.66958 4.99515 8.56447 4.72534 9.48501 4.66725C10.4056 4.60915 11.3271 4.76433 12.1783 5.12078C12.3244 5.17606 12.3853 5.12078 12.4646 5.02865C13.045 4.34807 13.4581 3.5402 13.6705 2.67009C13.7907 2.22284 13.86 1.76218 13.9426 1.30487C13.9571 1.17754 14.0195 1.06058 14.1171 0.977912C14.2147 0.895241 14.3401 0.853108 14.4676 0.860131C14.5313 0.863836 14.5935 0.881085 14.6501 0.910737C14.7067 0.940388 14.7563 0.981765 14.7958 1.03213C14.8353 1.08249 14.8636 1.14069 14.879 1.20287C14.8943 1.26505 14.8963 1.3298 14.8849 1.39282C14.8072 1.90708 14.6954 2.41715 14.5961 2.9289C14.5861 3.00846 14.5594 3.08384 14.5452 3.1408Z",
    fill: "url(#paint0_linear_11520_37409)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11520_37409",
    x1: 14.3929,
    y1: 9.67714,
    x2: -1.82986,
    y2: 20.3592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321569,
    stopColor: "#ED7E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631373,
    stopColor: "#F5B223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6BB22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagMangoWithoutBorder);
export default __webpack_public_path__ + "static/media/TagMangoWithoutBorder.5f4b631b41eff2a002420b0953e485fc.svg";
export { ForwardRef as ReactComponent };